import React from "react";
import { Grid, Typography } from "@mui/material";
import PremiumInput from "../../../../Components/Inputs/PremiumInput";
import PremiumSelect from "../../../../Components/Inputs/PremiumSelect";
import CustomPersianDatePicker from "../../../../Components/CustomPersianDatePicker";

const GENDER_OPTIONS = [
  { value: "male", label: "مرد" },
  { value: "female", label: "زن" },
  { value: "not_specified", label: "مشخص نشده" },
];

const MILITARY_SERVICE_OPTIONS = [
  { value: "completed", label: "پایان خدمت" },
  { value: "exempt", label: "معافیت (پزشکی، تحصیلی و...)" },
  { value: "ongoing", label: "در حال خدمت" },
  { value: "not_applicable", label: "مشمول نمی‌شود (برای خانم‌ها)" },
];

const PERSONAL_FIELDS = [
  { name: "first_name", label: "نام", size: { xs: 12, md: 6 } },
  { name: "last_name", label: "نام خانوادگی", size: { xs: 12, md: 6 } },
  { name: "father_name", label: "نام پدر", size: { xs: 12, md: 6 } },
  { name: "national_code", label: "کد ملی", size: { xs: 12, md: 6 } },
  { name: "phone_number", label: "شماره تماس", size: { xs: 12, md: 6 } },
  { name: "email", label: "ایمیل (اختیاری)", size: { xs: 12, md: 6 } },
  { name: "address", label: "آدرس", size: { xs: 12 }, multiline: true },
];

export default function PersonalInfoSection({ formik }) {
  const gender = formik?.values?.gender;

  return (
    <>
      <Typography
        sx={{ color: "#00ffcc", fontWeight: 700, mb: 2, mt: 4 }}
        component="h2"
      >
        اطلاعات فردی و تماس
      </Typography>

      <Grid container>
        {PERSONAL_FIELDS.map((field, index) => (
          <Grid size={field?.size} key={`personal-${index}`} p={1}>
            <PremiumInput
              name={field?.name}
              label={field?.label}
              multiline={field?.multiline || false}
              placeholder={field?.placeholder}
              inputProps={{ "aria-label": field?.label }}
              formik={formik}
            />
          </Grid>
        ))}

        <Grid size={{ xs: 12, md: 6 }} p={1}>
          <CustomPersianDatePicker
            name="birth_date"
            label="تاریخ تولد"
            placeholder="انتخاب تاریخ تولد"
            formik={formik}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <PremiumSelect
            name="gender"
            label="جنسیت"
            options={GENDER_OPTIONS}
            formik={formik}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <PremiumSelect
            name="military_service"
            label="وضعیت سربازی"
            options={MILITARY_SERVICE_OPTIONS}
            disabled={gender !== "male"}
            formik={formik}
          />
        </Grid>
      </Grid>
    </>
  );
}
